// src/data/social-links.ts
import {
  IconFacebookLogo,
  IconInstagramLogo,
  IconLinkedinLogo,
  IconXLogo,
  IconYoutubeLogo
} from "../assets/icons/index.mjs";
var socialLinks = [
  {
    label: "X",
    link: "https://x.com/Checkatrade",
    icon: IconXLogo
  },
  {
    label: "Facebook",
    link: "https://www.facebook.com/VettedLtd",
    icon: IconFacebookLogo
  },
  {
    label: "Instagram",
    link: "https://www.instagram.com/Checkatrade/",
    icon: IconInstagramLogo
  },
  {
    label: "YouTube",
    link: "https://www.youtube.com/user/checkatrade",
    icon: IconYoutubeLogo
  },
  {
    label: "LinkedIn",
    link: "https://www.linkedin.com/company/checkatrade/",
    icon: IconLinkedinLogo
  }
];
export {
  socialLinks
};
